import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AppTokenHandler } from 'src/app/Global-Services/app-token-handler';
import { CommonService } from 'src/app/Global-Services/common.service';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import * as FileSaver from 'file-saver';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-initiate-records-fte',
  standalone: false,
  templateUrl: './initiate-records-fte.component.html',
  styleUrl: './initiate-records-fte.component.css'
})
export class InitiateRecordsFteComponent implements OnInit {

  ErrorMessage = [];
    EmployeeName: string[];
    filteredEmployeeSingle: any [] =[];
    EmployeeList = {
      Employee: null,
      EmployeeGPN: null,
      EmpCode: null
    };
    SearchUserGPN: string = '';
    SearchUserName: string = '';
    SearchUserLPN: string = '';
    isLoading: boolean = false;
    IsNotExist: boolean = false;
    isVisible: boolean = true;
    formData: any;
    RevisedContractEnd: null;
    InitiateRecord = {
    EmpGPN: '',
    EmpLPN: '',
    EmpName: '',
    EmpEmail: '',
    EmpTitle: '',
    EmpLocation: '',
    EmpCouncelorGPN: '',
    EmpCouncelorName: '',
    EmpManagerGPN: '',
    EmpManagerName: '',
    EmpPartnerGPN: '',
    EmpPartnerName: '',
    EmpJoiningDate: '',
    EmpMobile: '',
    EmpCUG: '',
    EmpLegalEntity: '',
    EmpBUDesc: '',
    EmpStatus: '',
    EmpOfficeAddress: '',
    EmployeeType: '',
    CompetencyName: '',
    ServiceLine: '',
    Reason: '',
    AttachmentName: '',
    AttachmentID: 0,
    RevisedContractEndDate: null,
    Eligible: false,
    CurrentUserGPN: '',
    Type: '',
    }
    @ViewChild("fileInput") fileInput!: ElementRef;

    constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService,
        public gService: CommonService, public datepipe: DatePipe, private gVariable: GlobalVariable,
        private appTokenHandler: AppTokenHandler, public dialog: MatDialog, private _router: Router,
        private el: ElementRef,private cd: ChangeDetectorRef, private dateAdapter: DateAdapter<Date>) { }


  ngOnInit() {
      this.filteredEmployeeSingle = [];
      this.InitiateRecord.CurrentUserGPN = this.gVariable.User.UserGPN;
    }

    SubmitInitiateRecord(type: any)
    {
      this.ErrorMessage = [];
      this.InitiateRecord.Type = type;

    if (this.InitiateRecord.Reason == null || this.InitiateRecord.Reason == '') {
      this.ErrorMessage.push({ message: 'Please enter reason.' });
    }
    if (this.InitiateRecord.Eligible == false ) {
      this.ErrorMessage.push({ message: 'Please select Eligible as FTE.' });
    }
    if (this.InitiateRecord.RevisedContractEndDate == null) {
      this.ErrorMessage.push({ message: 'Please enter Revised Contract End Date.' });
    }
     if (this.ErrorMessage.length > 0) {
      return;
    }
    var boolReturn = false;
        boolReturn = confirm('Are you sure you want to initiate the record?');
        if (boolReturn === false) {
          return;
        }
        this.gService.PostService(this.InitiateRecord, 'FTEDetails/SubmitInitiateRecord').subscribe(data => {
          if(data != null && data != "" && data.toLowerCase() != "success")
          {
            alert("Employee is not an eligible FTE/Retainer.");
            return;
          }
          alert("Data Submitted Successfully!");
          this._router.navigate(['/INFTE/home']);
        },
          (err: HttpErrorResponse) => {
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this.gService.RedirectToErrorPage(2);
          });

    }

     onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this._router.navigate(['/INFTE/home']);
    }
  }

  GetEmpSearch(event: any, isGPNFilter: boolean = false) {
      const query = event.query;
      if ((query.length) >= 3) {
        this.gService.GetEmployeeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
          if (data!=null && data.length > 0) {
            this.filteredEmployeeSingle = data;
          } else {
            this.EmployeeName = [];
            this.filteredEmployeeSingle = [];
          }
          this.isLoading = false;
        },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this.gService.RedirectToErrorPage(2);
          });
      }
    }


  OnClearSendUser() {
    this.SearchUserName = null;
    this.SearchUserGPN = null;
    this.SearchUserLPN = null;
    this.EmployeeList.Employee = null
    this.EmployeeList.EmployeeGPN = null
  }

  SetSelectedEmpGPN(event: any) {
    this.SearchUserName = event.value.EmpName;
    this.SearchUserGPN = event.value.EmpGPN;
    this.SearchUserLPN = event.value.EmpCode;
  }

  GetSearchFTERecord()
  {
    this.isLoading = true;
    const param = {
    'UserGPN': this.SearchUserGPN,
    'UserLPN': this.SearchUserLPN,
    }
    this.gService.PostService(param, 'FTEDetails/GetFTEReordExistOrNot').subscribe((data: any) => {
      if (data != null && data.length > 0) {
        if(data[0].Exist == 'Exist')
        {
          if(data[0].RequestStatusID == 12)
          {
            this._router.navigate(['/View/ViewPendingToBeInitiated/6']);
          }
          else
          {
            this._router.navigate(['/View/FTEDetails/' + data[0].IDEncrypt]);
          }
        }
      else {
        this.IsNotExist = true;
        this.isVisible = false;
        this.InitiateRecord.EmpLPN = data[0].EmpLPN;
        this.InitiateRecord.EmpGPN = data[0].EmpGPN;
        this.InitiateRecord.EmpName = data[0].EmpName;
        this.InitiateRecord.EmpEmail = data[0].EmpEmail;
        this.InitiateRecord.EmpTitle = data[0].EmpTitle;
        this.InitiateRecord.EmpLocation = data[0].EmpLocation;
        this.InitiateRecord.EmpCouncelorGPN = data[0].EmpCouncelorGPN;
        this.InitiateRecord.EmpCouncelorName = data[0].EmpCouncelorName;
        this.InitiateRecord.EmpManagerGPN = data[0].EmpManagerGPN;
        this.InitiateRecord.EmpManagerName = data[0].EmpManagerName;
        this.InitiateRecord.EmpPartnerGPN = data[0].EmpPartnerGPN;
        this.InitiateRecord.EmpPartnerName = data[0].EmpPartnerName;
        this.InitiateRecord.EmpJoiningDate = data[0].EmpJoiningDate;
        this.InitiateRecord.EmpMobile = data[0].EmpMobile;
        this.InitiateRecord.EmpCUG = data[0].EmpCUG;
        this.InitiateRecord.EmpLegalEntity = data[0].EmpLegalEntity;
        this.InitiateRecord.EmpBUDesc = data[0].EmpBUDesc;
        this.InitiateRecord.EmpStatus = data[0].EmpStatus;
        this.InitiateRecord.EmpOfficeAddress = data[0].EmpOfficeAddress;
        this.InitiateRecord.EmployeeType = data[0].EmployeeType;
        this.InitiateRecord.CompetencyName = data[0].ServiceLine;
        this.InitiateRecord.ServiceLine = data[0].CompetencyName;
        this.InitiateRecord.Reason = '',
        this.InitiateRecord.AttachmentName = '';
        this.InitiateRecord.AttachmentID = 0;
        this.InitiateRecord.RevisedContractEndDate = null,
        this.InitiateRecord.Eligible =  false;
        this.RevisedContractEnd = null;
      }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  ResetResult()
  {
    this.OnClearSendUser();
    this.IsNotExist = false;
    this.isVisible = true;
    this.ErrorMessage = [];
    this.InitiateRecord.EmpGPN = '';
    this.InitiateRecord.EmpLPN = '';
    this.InitiateRecord.EmpName = '';
    this.InitiateRecord.EmpEmail = '';
    this.InitiateRecord.EmpTitle = '';
    this.InitiateRecord.EmpLocation = '';
    this.InitiateRecord.EmpCouncelorGPN = '';
    this.InitiateRecord.EmpCouncelorName = '';
    this.InitiateRecord.EmpManagerGPN = '';
    this.InitiateRecord.EmpManagerName = '';
    this.InitiateRecord.EmpPartnerGPN = '';
    this.InitiateRecord.EmpPartnerName = '';
    this.InitiateRecord.EmpJoiningDate =  '';
    this.InitiateRecord.EmpMobile = '';
    this.InitiateRecord.EmpCUG = '';
    this.InitiateRecord.EmpLegalEntity = '';
    this.InitiateRecord.EmpBUDesc = '';
    this.InitiateRecord.EmpStatus = '';
    this.InitiateRecord.EmpOfficeAddress = '',
    this.InitiateRecord.EmployeeType = '';
    this.InitiateRecord.CompetencyName =  '';
    this.InitiateRecord.ServiceLine = '';
    this.InitiateRecord.Reason = '',
    this.InitiateRecord.AttachmentName = '';
    this.InitiateRecord.AttachmentID = 0;
    this.InitiateRecord.RevisedContractEndDate = null,
    this.InitiateRecord.Eligible =  false;
    this.RevisedContractEnd = null;
  }

  UploadAttachment(event) {
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.InitiateRecord.AttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'png' || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'msg') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 5 mb.');
          this.clearFileInput();
          this.InitiateRecord.AttachmentName = '';
          this.InitiateRecord.AttachmentID = 0;
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.gService.UploadAttachment(this.formData, 'FTEDetails/UploadAttachment').subscribe(data => {
          if(data == "Success")
          {
          }
          else
          {
            this.isLoading = false;
            alert(data);
            this.InitiateRecord.AttachmentName = '';
          this.InitiateRecord.AttachmentID = 0;
            this.clearFileInput();
          }

        });
      } else {
        alert('Please upload pdf/jpeg/png/msg file.');
        this.clearFileInput();
        this.formData = null;
        this.InitiateRecord.AttachmentName = '';
          this.InitiateRecord.AttachmentID = 0;
      }
    }
  }

  GetAttachmentbyAttachmentID()
  {
    if(this.InitiateRecord.AttachmentID == 0)
    {
    this.gService.Download('FTEDetails/GetAttachmentbyAttachmentName?attachmentName=' + this.InitiateRecord.AttachmentName).subscribe((data: any) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, this.InitiateRecord.AttachmentName);
      });
    }
    else
    {
      this.gService.Download('FTEDetails/GetAttachmentbyAttachmentID?ID=' + this.InitiateRecord.AttachmentID).subscribe((data: any) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
              FileSaver.saveAs(blob, this.InitiateRecord.AttachmentName);
          });
    }
  }

  clearFileInput() {
    this.fileInput.nativeElement.value = "";
  }

  blockSpecialChar(event: any) {
    try {
      let k;

      if (event.key !== undefined) {
        k = event.key.charCodeAt(0);
      } else {
        document.all ? k = event.keyCode : k = event.which;
      }
      return ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 45);
    }
    catch (error) {
      console.log(error);
      return;
    }
  }

  DeleteAttachment()
  {
    let boolReturnConfirm = false;
    boolReturnConfirm = confirm('Are you sure you want to delete');
    if (boolReturnConfirm === false) {
      return;
    }

    if (this.InitiateRecord.AttachmentName != null || this.InitiateRecord.AttachmentName != "") {
      this.gService.PostService({ FileName: this.InitiateRecord.AttachmentName },
        'FTEDetails/DeleteUploadedFile').subscribe(data => {

          if (data === 'Success') {
           this.InitiateRecord.AttachmentName = '';
          this.InitiateRecord.AttachmentID = 0;
            this.clearFileInput();
          }
        },
          (err: HttpErrorResponse) => {
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this._router.navigate(['/error/2']);
          });
    } else {
      this.InitiateRecord.AttachmentName = '';
          this.InitiateRecord.AttachmentID = 0;
            this.clearFileInput();
    }
  }


  RevisedContractEndDateChange(event: MatDatepickerInputEvent<Date>) {
    if (event.value != null) {
      const selectedDate = event.value;
      const timezoneOffset = selectedDate.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(selectedDate.getTime() - timezoneOffset);
      const isoDate = adjustedDate.toISOString().split('T')[0];
      this.InitiateRecord.RevisedContractEndDate = isoDate;
    }
  }
}
